export default "__VITE_ASSET__DsW9U7rf__"